export const DataSources = {
    QUADENCY: 'QUADENCY',
    CRYPTOWATCH: 'CRYPTOWATCH',
};

export const PlacementsDataSources = {
    DEFAULT: DataSources.QUADENCY,
    HUOBI: DataSources.CRYPTOWATCH,
};
